module.exports = __webpack_public_path__ + "img/tintuc14.bb5307f3.png";